import { takeEvery } from '@zaibot/fsa-saga';
import { fork, put } from '../../redux-saga';
import HIDE from './actions/HIDE';
import AUTHENTICATED from '../../auth/actions/AUTHENTICATED';
import FLYOVER_HIDE from '../../note/flyover/actions/HIDE';

export default function* rootSaga() {
    yield fork(updateEditors);
}
 
function* updateEditors() {
    yield takeEvery([AUTHENTICATED, FLYOVER_HIDE], function*(action) {
        // Popup
        yield put(HIDE({}));
    });
}



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/note/noteParticipantSelectPopup/sagas.tsx